function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.65 7.65l-2.8-2.8A.5.5 0 013.21 4H6.8c.13 0 .26.05.35.15l5 5a.5.5 0 01-.35.85H8.51c-1.93 0-3.5 1.57-3.5 3.5S6.58 17 8.51 17h1.5l2.15 2.15a.5.5 0 01-.35.85H8.52A6.5 6.5 0 015.49 7.75l.16-.1z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M18.35 16.35l2.8 2.8a.5.5 0 01-.35.85h-3.59a.47.47 0 01-.35-.15l-5-5a.5.5 0 01.35-.85h3.29c1.93 0 3.5-1.57 3.5-3.5S17.43 7 15.5 7H14l-2.15-2.15a.5.5 0 01.36-.85h3.29a6.5 6.5 0 013.03 12.25l-.18.1z"
})));